import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetCartData, updateWording, ClearBuyNow } from '../../../store/actions';
import { queryStringToJSON } from '../../../utils';
import { Link } from 'react-router-dom';

const PaymentRespSuccess = (props) => {
    const dispatch = useDispatch();
    const currentLanguage = useSelector(({ language }) => language.currentLanguage);
    const navbarCategory = useSelector(({ navigation }) => navigation.navbarCategory);
    const wording = useSelector(({ language }) => language.wording);

    const [orderType, setOrderType] = useState();
    const [invoice, setInvoice] = useState();

    useEffect(() => {
        dispatch(updateWording());
    });

    useEffect(() => {
        let query = queryStringToJSON(props.location.search);
        if (query.hasOwnProperty("orderType"))
            setOrderType(query.orderType);
        if (query.hasOwnProperty("invoice"))
            setInvoice(query.invoice);
        dispatch(ClearBuyNow(null, true));
        dispatch(GetCartData(true));
    }, [dispatch]);

    const createPaymentSuccessPage = (wording) => {
        return (
            <>
                <section
                    style={{
                        backgroundColor: '#7e7e7e',
                        paddingTop: 20,
                        paddingBottom: 20
                    }}>
                    <div className='container relative clearfix'>
                        {/* <h1 className='uppercase'>{wording.paymentSuccessPage.title}</h1> */}
                        <ol className='breadcrumb'>
                            <li>
                                <a href='/'>
                                    {currentLanguage === 'TH'
                                        ? navbarCategory[0].categoriesNameTh
                                        : navbarCategory[0].categoriesNameEn}
                                </a>
                            </li>
                            <li className='active'>{wording.title}</li>
                        </ol>
                    </div>
                </section>

                <section className='section-wrap-sm'>
                    <div className='container'>
                        <div className='text-center'>
                            <div>
                                <div className='icon-warpper'>
                                    <img src='/assets/img/sf/payment-success.png' alt='payment-success.png' />
                                </div>
                            </div>
                            <h1 className='uppercase'>{wording.bodyMessage.line1}</h1>
                            <h5>{wording.bodyMessage.line2}</h5>
                            <h5>{wording.bodyMessage.line3}</h5>
                            <p className='white'>
                                {wording.urlMessage1}{' '}
                                <Link to={invoice ? `user/purchase/${invoice}` : orderType == "voucher" ? 'user/voucher': '/user/purchase'}>{wording.urlMessage2}</Link>
                            </p>
                        </div>
                    </div>
                </section>
            </>
        )
    }

    return (
        <>
            {
                orderType == "voucher" 
                    ? createPaymentSuccessPage(wording.paymentvoucherSuccessPage)
                    : createPaymentSuccessPage(wording.paymentSuccessPage)
            }
        </>
    );
}

export default PaymentRespSuccess;
